import { isPromiseLike } from 'retil-support';
export var nullSource = [
    [function () { return null; }, function (_) { return function () { }; }],
    function (_) { return null; },
    function (cb) { return Promise.resolve(cb()); },
];
export function act(source, callback) {
    return source[2](callback);
}
export function getSnapshot(_a) {
    var core = _a[0], select = _a[1];
    return select(core);
}
export function getSnapshotPromise(_a) {
    var core = _a[0], select = _a[1];
    try {
        return Promise.resolve(select(core));
    }
    catch (errorOrPromise) {
        if (isPromiseLike(errorOrPromise)) {
            return Promise.resolve(errorOrPromise).then(function () { return select(core); });
        }
        return Promise.reject(errorOrPromise);
    }
}
export function hasSnapshot(_a) {
    var core = _a[0], select = _a[1];
    try {
        select(core);
    }
    catch (errorOrPromise) {
        if (isPromiseLike(errorOrPromise)) {
            return false;
        }
    }
    return true;
}
export function subscribe(source, callback) {
    return source[0][1](callback);
}
export var identitySelector = function (core) { return core[0](); };
